"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextOverflowing = void 0;
function isTextOverflowing(element) {
    // Check for horizontal overflow
    return element && element.scrollWidth > element.clientWidth;
}
exports.isTextOverflowing = isTextOverflowing;
